import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from 'react-icons/md';
import { IconButton } from '@ds';

type ClinicalNavigationProps = {
  label?: string;
  prev?: () => void;
  next?: () => void;
  prevDisabled?: boolean;
  nextDisabled?: boolean;
};

export const ClinicalNavigation = ({ label, prev, next, prevDisabled, nextDisabled }: ClinicalNavigationProps) => {
  return (
    <div className="flex items-center justify-between gap-4">
      <span className="text-s-r text-base-20">{label}</span>
      <div className="flex gap-1">
        <IconButton
          aria-label="navigate previous"
          className="bg-base-55 h-5 w-5 transition"
          variant="light"
          disableRipple
          startContent={<MdKeyboardArrowLeft size={14} />}
          onClick={prev}
          isDisabled={prevDisabled}
        />
        <IconButton
          aria-label="navigate next"
          className="bg-base-55 transition h-5 w-5"
          variant="light"
          disableRipple
          startContent={<MdKeyboardArrowRight size={14} />}
          onClick={next}
          isDisabled={nextDisabled}
        />
      </div>
    </div>
  );
};
